import {mapState,mapGetters} from 'vuex'
import Vue from 'vue';


export var locationMixin = {
  watch: { 
    '$route.params': {
      handler: function(params) {
          if(params){
            this.urlLocationId=params.id;
            this.urlEdit=(params.edit)?!!JSON.parse(params.edit):false; // String to Boolean
          }
      },
      deep: true,
      immediate: true
    }
  },
  data(){
    return{
      urlEdit:false,
      urlLocationId:null,
      lastStoredFields:null
    }
  },
  computed: {
    ...mapGetters('locations',['firstLocation','firstXLocations','allLocations']),
    ...mapState('locations',['locations','location_loading','location_error']),
  },
  methods: {
    setLocationLoading(isLoading){
      this.$store.commit('locations/SET_LOCATION_LOADING', isLoading)
    },
    addLocationObject(location){
      this.$store.commit('locations/ADD_LOCATION', location)
    },
    updateLocationObject(location,data){
      let updateModel={
        location:location,
        data:data
      };
      this.$store.commit('locations/UPDATE_LOCATION', updateModel)
    },
    getLocations(data){
      return this.$store.dispatch('locations/getLocations',data);
    },
    getLocationById(id){
      return this.$store.dispatch('locations/getLocationById',id);
    },
    
    getMyLocations(userId,data){
      let model={
        userId:userId,
        data:data
      };
      return this.$store.dispatch('locations/getMyLocations',model);
    },
    createLocation(data){
      return this.$store.dispatch('locations/createLocation',data);
    },
    updateLocation(data){
      return this.$store.dispatch('locations/createLocation',data);
    },
    deleteLocation(data){
      return this.$store.dispatch('locations/deleteLocation',data);
    },
    finishLocation(data){
      return this.$store.dispatch('locations/finishLocation',data);
    },
    checkPricing(price){
      return this.$store.dispatch('locations/checkPricing',price);
    },
    
    locationEntryHasChanged(newObj,oldObj){
      return (!Vue._.isEqual(newObj,oldObj));//(null!=oldObj)&& 
    },
    storeLocationOnServer(entry,user){
      return new Promise((resolve, reject) => {
        if(entry && user){
          let serverFriendlyObject=Vue._.cloneDeep(entry);
          serverFriendlyObject.user=Vue._.cloneDeep(user);
          if(this.locationEntryHasChanged(serverFriendlyObject,this.lastStoredFields)){
            this.createLocation(serverFriendlyObject).then(()=>{
              //Success
              this.lastStoredFields=serverFriendlyObject;
              console.log('Created location successfully');
              resolve();
            }).catch((ex)=>{
              console.warn(ex);
              reject();
            })
          }else{
            resolve();
          }
        }else{
          reject();
          console.warn('User is empty. Need it to store location');
        }
      })
    },
    getLocationByUser(userId,locationId,isOwnerOrAdmin){
      return new Promise((resolve, reject) => {
        let data=(isOwnerOrAdmin)?{id:locationId}:{}; // Tweak to receive location of location for admin edit
        this.getMyLocations(userId,data).then(()=>{//locations
          //TODO aktuell nur eine Location
          //Set Default if null
          if(this._.isEmpty(this.firstLocation)){
            this.addLocationObject(this.dataFieldsDefault);
          }
          resolve()

        }).catch((ex) => {
          console.log(ex);
          console.log('Get Location error');
          reject()
        })
      })
    },
  }
}
